import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authRequest } from "../utils/auth"; // 토큰 처리 유틸리티
import "../css/Dashboard.css";

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();
  const [profilePicture, setProfilePicture] = useState("");
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // 로그인 상태 관리
  const username = localStorage.getItem("username");

  // 프로필 데이터 및 로그인 상태 가져오기
  const fetchProfile = async () => {
    try {
      const response = await authRequest(
        "http://35.192.131.111/user/my_profile/",
        {
          method: "GET",
        }
      );
      if (response.data.result) {
        setProfilePicture(response.data.data.profile_picture);
        setIsLoggedIn(true); // 로그인 상태로 설정
      } else {
        setError("프로필 정보를 불러올 수 없습니다.");
      }
    } catch (error) {
      setError("프로필 데이터를 가져오는 중 오류가 발생했습니다.");
      console.error("Error fetching profile data:", error);
      setIsLoggedIn(false); // 오류가 발생하면 로그아웃 상태로 표시
    }
  };

  // 컴포넌트 마운트 시 로그인 상태 확인
  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      setIsLoggedIn(true); // 토큰이 있으면 로그인 상태로 설정
      fetchProfile(); // 프로필 정보 가져오기
    } else {
      setIsLoggedIn(false); // 토큰이 없으면 로그아웃 상태로 설정
      setError("로그인이 필요합니다.");
    }
  }, [username]);

  return (
    <section id="dashboard">
      <div className="dashboard-container">
        <div className="dashboard-Profile">
          <h1>
            {isLoggedIn ? username || "사용자 이름" : "로그인이 필요합니다"}
          </h1>
          {isLoggedIn ? (
            <img src={profilePicture || "./image/프로필.png"} />
          ) : (
            <p>로그인 후 프로필을 확인하세요.</p>
          )}
        </div>
        <p>{isLoggedIn ? "일반회원" : "로그아웃 상태"}</p>
        <div className="dashboard-Button">
          {isLoggedIn ? (
            <>
              <button className="dashboard-link">쪽지함</button>
              <button className="dashboard-link">프로필</button>
              <button className="dashboard-link">내정보</button>
              <button
                onClick={() => {
                  onLogout();
                  setIsLoggedIn(false);
                }}
                className="dashboard-LogOutlink"
              >
                로그아웃
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="dashboard-LogInlink"
            >
              로그인
            </button>
          )}
        </div>
        {error && <p className="error">{error}</p>}
      </div>
    </section>
  );
};

export default Dashboard;
